/* eslint-disable react/no-array-index-key */
import React from 'react'
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'

import DiscoBallWithStar from 'src/images/svgs/icons/DiscoBallWithStar.svg'

import { generateRandomId } from 'src/utils/domHelper'
import * as Styles from './staggeredImageCards.module.scss'

export type StaggeredImageCard = {
  subtitle?: string
  title?: string
  image?: IGatsbyImageData
  imageAlt?: string
}

export type StaggeredImageCardsContent = {
  anchor?: string
  showDecorations?: boolean
  items?: StaggeredImageCard[]
}

type Props = {
  content: StaggeredImageCardsContent
}

const StaggeredImageCards = ({ content }: Props) => {
  const {
    anchor = generateRandomId(),
    showDecorations = true,
    items = [],
  } = content

  return (
    <section id={anchor} className={Styles.staggeredImageCards}>
      <div className={Styles.inner}>
        {showDecorations && (
          <div aria-hidden="true" className={Styles.decorations}>
            <div className={Styles.discoBall}>
              <DiscoBallWithStar />
            </div>
          </div>
        )}

        <div className={Styles.cards}>
          {items.map((item, i) => {
            const { subtitle = '', title = '', image, imageAlt = '' } = item
            return (
              <div
                className={Styles.card}
                key={`staggered-card-${anchor}-${i}`}
              >
                <div className={Styles.imageWrapper}>
                  {!!image && (
                    <GatsbyImage
                      image={image}
                      alt={imageAlt}
                      className={Styles.image}
                    />
                  )}
                </div>
                <div className={Styles.caption}>
                  {!!subtitle && <p className={Styles.subtitle}>{subtitle}</p>}
                  {!!title && <p className={Styles.title}>{title}</p>}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default StaggeredImageCards
